/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_EyebrowInputs */

const tr_kvkkbasvuru_eyebrow = /** @type {(inputs: Kvkkbasvuru_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK · Başvuru Formu`)
};

const en_kvkkbasvuru_eyebrow = /** @type {(inputs: Kvkkbasvuru_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK · Application Form`)
};

const de_kvkkbasvuru_eyebrow = /** @type {(inputs: Kvkkbasvuru_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK · Antragsformular`)
};

const ru_kvkkbasvuru_eyebrow = /** @type {(inputs: Kvkkbasvuru_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK · Форма обращения`)
};

/**
* | output |
* | --- |
* | "KVKK · Application Form" |
*
* @param {Kvkkbasvuru_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_eyebrow = /** @type {((inputs?: Kvkkbasvuru_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_eyebrow(inputs)
	if (locale === "de") return de_kvkkbasvuru_eyebrow(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_eyebrow(inputs)
	return tr_kvkkbasvuru_eyebrow(inputs)
});